// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__pM3HW","popup":"styles_popup__dgcPp"};